<div class="caption">{{label}}</div>
<div class="description" *ngIf="!isBoolean">{{ value }}</div>
<div class="description blank" *ngIf="!isBoolean && !value">(blank)</div>
<div class="description" *ngIf="isBoolean && value">Yes</div>
<div class="description" *ngIf="isBoolean && !value">No</div>